// A week played against the field: each team's place and its all-play record
// that week. Pure. Scenarios Q4 and Q5, PLAN-2026-10-16-league-formats §2.
//
// ONE RULE FOR THE ENGINE AND THE READS: the standings count an all-play week
// from it, and Game Day, the scoreboard and Home say a team's *3rd* and *7–2*
// from it, so the table and the screen cannot count a tie differently.

/** One team's week against every other team's. */
export interface FieldResult {
  /** 1 for the top score; teams on the same score share a place. */
  place: number;
  /** Teams this one outscored, was outscored by, and scored level with. */
  wins: number;
  losses: number;
  ties: number;
}

/**
 * Every team's place and all-play record for one week, from the week's
 * scores. A team set against a team on the same score ties it; the place is
 * one more than the number of teams that scored more, so two teams level at
 * the top are both first and the next is third, as a table counts.
 */
export function fieldResults(
  scores: readonly { teamId: string; score: number }[],
): Map<string, FieldResult> {
  const out = new Map<string, FieldResult>();
  for (const me of scores) {
    let wins = 0;
    let losses = 0;
    let ties = 0;
    for (const other of scores) {
      if (other.teamId === me.teamId) continue;
      if (me.score > other.score) wins += 1;
      else if (me.score < other.score) losses += 1;
      else ties += 1;
    }
    out.set(me.teamId, { place: losses + 1, wins, losses, ties });
  }
  return out;
}
